function NotFound () {
    return(
        <section>
            <h1>Not Found</h1>
        </section>
    )
}

export default NotFound;